import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { logOutUser } from "../redux/reducer";
import { useDispatch } from "react-redux";

const Container = styled.div`

`;

const Title=styled.div`
  color: antiquewhite;
`
const Div = styled.div`
  background-color: #055646;
  width: 250px;
  margin-right: 20px;
  padding: 30px;
  height: calc(100vh - 50px);
`;

const SidebarNav = () => {
  const dispatch=useDispatch();
  const navigate = useNavigate();

  const handlelogout = () => {
    dispatch(logOutUser());
    navigate("/logreg");
  };

  return (
    <Container>
      <Div>
        <Title>Welcome to E-Learning</Title>

        <div>
          <Link to="/">
          <div style={{fontSize:"1.2rem", color:'lightblue', marginTop:"30%"}}>My Courses</div>
          </Link>

          <button
            onClick={() => {
              handlelogout();
            }}
            style={{marginTop:"100%"}}
          >
            Log out
          </button>
        </div>
      </Div>
    </Container>
  );
};

export default SidebarNav;
